import React from "react";
import "./SearchTag.css";
import { CloseOutlined } from "@ant-design/icons";

export default function SearchTag({ text, deleteTag }) {
  return (
    <button className="st-delete-button" onClick={() => deleteTag(text)}>
      <div className="st-container">
        <span className="st-text">{text}</span>
        <div className="st-delete-button-container">
          <CloseOutlined />
        </div>
      </div>
    </button>
  );
}
